<template lang="pug">
.l-article(
  :class="{hotoke:store.ui.state.hotoke}"
)
  ArticleScroll
    ArticleBackBtn
    ArticleHeader
    ArticleContent
    ArticleIllust
    ArticleFooter

</template>



<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-article
  background-color #f6f5f1
  line-height 2
  &.hotoke
    background-color #3d3d3d
    color #FFF
  +pc()
    wh(550px,100vh)
    // posr(-550px,0,100)
    posr(0px,0,90)
  +sp()
    wh(680px,calc(100% - 35px))
    // posb(35px,calc(-100vh + 35px),100)
    posb(35px,0,90)
    border-radius 20px 20px 0 0

</style>


<script>
import { defineComponent, computed, ref, reactive ,onMounted, onUpdated, onBeforeUnmount , onUnmounted } from "vue"
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import ArticleBackBtn from '@/components/article/ArticleBackBtn.vue'
import ArticleScroll from '@/components/article/ArticleScroll.vue'
import ArticleHeader from '@/components/article/ArticleHeader.vue'
import ArticleContent from '@/components/article/ArticleContent.vue'
import ArticleIllust from '@/components/article/ArticleIllust.vue'
import ArticleFooter from '@/components/article/ArticleFooter.vue'
import GtagManager from '@/lib/gtagmanager.js'


export default defineComponent({
  components:{
    ArticleBackBtn,
    ArticleScroll,
    ArticleHeader,
    ArticleContent,
    ArticleIllust,
    ArticleFooter
  },

  setup(props, context) {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const hotoke = computed(()=>{
      return store.ui.state.easyinfo.mapdata.hotoke
    })

    onMounted(async ()=>{
      console.log('article mounted!',route.params.id)

      store.ui.state.article.loading = true
      //該当スポットを取得（まだデータ未取得の場合）
      if(!store.api.getSpotById(route.params.id).id){
        await store.api.initSpot(route.params.id)
      }
      store.ui.state.article.show = true
      store.ui.state.article.name = store.api.getSpotById(route.params.id).name
      store.ui.state.article.loading = false

      //初期状態かつ初回アクセスがArticleの時はマップの状態と仏モードをセット
      if(!store.ui.state.init && store.ui.state.firstRouteName == 'Article'){
        store.ui.state.maptype = store.api.getSpotById(route.params.id).maptype
        store.ui.state.hotoke = store.api.getSpotById(route.params.id).hotoke
      }

      //仏モードのためのcookieの更新
      if(store.api.getSpotById(route.params.id).id){
        store.ui.updateHotoke( store.api.getSpotById(route.params.id).id )
      }

      //gtag
      if(store.ui.state.init && store.api.getSpotById(route.params.id).id){
        GtagManager.send(
          router.currentRoute.value.fullPath,
          store.ui.state.meta.title
        )
      }

      //notfound
      if(!store.api.getSpotById(route.params.id).id){
        store.ui.state.article.notfound = true
      }

    })
    onUnmounted(()=>{
      // console.log('article unmounted!',route.params.id)
      store.ui.state.article.show = false

      //初期状態かつ初回アクセスがArticleの時はマップの状態と仏モードをセットし、
      //本当は仏モードに達していない時は仏モードを切る
      if(!store.ui.state.hotokeCountCheck && store.ui.state.hotoke){
        store.ui.state.hotoke = false
      }
    })

    return{
      store
    }
  }
})
</script>
